/* eslint-disable */
import axios from 'axios'

export const FileUtils = {

    forceFileDownload(response, fileName, pdf) {
        let url;
        if (pdf) {
            url = window.URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
        } else {
            url = window.URL.createObjectURL(new Blob([response.data]));
        }
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    downloadFile(query, fileName, url) {
        axios({
            url: process.env.VUE_APP_API_URL + url,
            method: 'post',
            responseType: 'blob',
            data: query,
        }).then((response) => {
            this.forceFileDownload(response, fileName);
        });
    },

    downloadFileUsingGET(fileName, url) {
        axios({
            url: process.env.VUE_APP_API_URL + url,
            method: 'get',
            responseType: 'blob',
        }).then((response) => {
            this.forceFileDownload(response, fileName);
        });
    },

    toSafeFileName(originalName, extension = 'txt', fallbackName = 'download') {
        if (!originalName) originalName = fallbackName;

        let safeName = originalName
            .normalize("NFD") // normalize accents
            .replace(/[\u0300-\u036f]/g, "") // remove accents
            .replace(/[^a-zA-Z0-9\s._-]/g, "") // remove invalid chars
            .trim()
            .replace(/\s+/g, "_"); // spaces to underscores

        if (!safeName) {
            safeName = fallbackName;
        }

        if (extension && !safeName.endsWith(`.${extension}`)) {
            safeName += `.${extension}`;
        }

        return safeName;
    }
};
